import { useEffect, useState, type AnchorHTMLAttributes, type PropsWithChildren } from "react";

export function navigate(to: string, replace = false): void {
  if (replace) window.history.replaceState({}, "", to);
  else window.history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
export function useLocation(): { pathname: string } {
  const [pathname, setPathname] = useState(window.location.pathname);
  useEffect(() => {
    const update = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", update);
    return () => window.removeEventListener("popstate", update);
  }, []);
  return { pathname };
}
export function Link({ to, children, onClick, ...props }: PropsWithChildren<{ to: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href">>) {
  return <a href={to} {...props} onClick={(event) => {
    onClick?.(event);
    if (!event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      navigate(to);
    }
  }}>{children}</a>;
}
export function NavLink({ to, children, className = "", ...props }: PropsWithChildren<{ to: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href">>) {
  const location = useLocation();
  return <Link to={to} className={`${className} ${location.pathname === to ? "active" : ""}`.trim()} {...props}>{children}</Link>;
}
